var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1416 28H7.85707C5.72668 28 4 26.2733 4 24.1429V7.85707C4 5.72668 5.72668 4 7.85707 4H24.1429C26.2733 4 28 5.72668 28 7.85707V24.1429C27.9987 26.2733 26.272 28 24.1416 28ZM9.14258 9.65222C8.59029 9.65222 8.14258 10.0999 8.14258 10.6522C8.14258 11.2045 8.59029 11.6522 9.14258 11.6522H22.8558C23.408 11.6522 23.8558 11.2045 23.8558 10.6522C23.8558 10.0999 23.408 9.65222 22.8558 9.65222H9.14258ZM9.14258 14.795C8.59029 14.795 8.14258 15.2427 8.14258 15.795C8.14258 16.3473 8.59029 16.795 9.14258 16.795H22.8558C23.408 16.795 23.8558 16.3473 23.8558 15.795C23.8558 15.2427 23.408 14.795 22.8558 14.795H9.14258ZM9.14258 19.9378C8.59029 19.9378 8.14258 20.3855 8.14258 20.9378C8.14258 21.49 8.59029 21.9378 9.14258 21.9378H22.8558C23.408 21.9378 23.8558 21.49 23.8558 20.9378C23.8558 20.3855 23.408 19.9378 22.8558 19.9378H9.14258Z",
    fill: "#5A5A62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSales);
export default __webpack_public_path__ + "static/media/activeSales.15c514406cb3934b6c09057c6674a86c.svg";
export { ForwardRef as ReactComponent };